import { useCallback, useEffect, useState } from 'react';

import { useRequest } from '@Contexts/Request';

import type { YandexSplitOptions } from '@Types/YandexSplitWidget';

export const useYandexPayInstance = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [YaPayInstance, setYaPayInstance] = useState<YandexSplitOptions | null>(null);
  const { isRus } = useRequest();

  const onLoad = useCallback(() => {
    const YaPay: YandexSplitOptions = window.YaPay;
    setYaPayInstance(YaPay);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!isRus) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const script = document.createElement('script');

    script.src = 'https://pay.yandex.ru/sdk/v1/pay.js';
    script.async = true;
    script.onload = onLoad;
    script.onerror = () => setIsLoading(false);

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [onLoad, isRus]);

  return { isLoading, YaPayInstance };
};

export default useYandexPayInstance;
